/**
 * Cấu hình → Thông tin tiệm → "Tải dữ liệu khách" (kế hoạch 10/2026, 5.5, ADR-094): chủ tiệm tải toàn bộ khách của mình
 * (tên, số điện thoại, số dư ví, gói còn buổi) thành một tệp CSV. Chỉ chủ tiệm — máy chủ kiểm quyền `xuat-khach`.
 */
import { Download } from 'lucide-react'
import { useState } from 'react'
import { khachApi } from './api.ts'
import { TD } from './text/tai-du-lieu-khach.ts'

export function TheTaiDuLieuKhach({
  onLoi,
  onXong,
}: {
  onLoi: (e: unknown) => void
  onXong: (cau: string) => void
}) {
  const [dang, setDang] = useState(false)
  async function tai() {
    setDang(true)
    try {
      await khachApi.taiDuLieu()
      onXong(TD.xong)
    } catch (e) {
      onLoi(e)
    } finally {
      setDang(false)
    }
  }
  return (
    <section className="the the-dem the-khoi">
      <h2>{TD.tieuDe}</h2>
      <p className="chu-phu">{TD.goiY}</p>
      <p className="chu-phu">{TD.khongGom}</p>
      <div className="hang-nut-cuoi">
        <button
          type="button"
          className="nut nut-vien nut-lon"
          disabled={dang}
          onClick={() => void tai()}
        >
          <Download size={20} />
          {dang ? TD.dang : TD.nut}
        </button>
      </div>
    </section>
  )
}
